export default __webpack_public_path__ + "static/media/stat-logo.87b56709.svg";